import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import ModalActions from 'components/ModalActions';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { answerQuestion, listChatQuestions, updateQuestion } from 'store/Orbita/Questions/actions';

import styles from '../../styles';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  classes: any;
  listChatQuestions: any;
  active: number;
  answerQuestion: any;
}

interface IStates {
  valueAnswer: string;
  modalDelete: boolean;
  chatActive: number;
  isFetchingRemove: boolean;
}

class Chat extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      valueAnswer: '',

      modalDelete: false,
      chatActive: 0,
      isFetchingRemove: false,
    };
  }

  handleClickAnswer = async () => {
    const { valueAnswer } = this.state;
    const { active } = this.props;

    if (valueAnswer.length > 1000) {
      toast.info('Por favor insira no máximo 1000 caracteres na resposta');
    } else {
      await this.props.dispatch(answerQuestion(active, valueAnswer));
      await this.props.dispatch(listChatQuestions(active));
    }
  };

  handleChangeFieldResponse = (e: any) => {
    this.setState({ valueAnswer: e.target.value });
  };

  handleVisibleShowcase = async (id: number, visible_public: boolean) => {
    const { active } = this.props;
    await this.props.dispatch(updateQuestion(active, id, { visible_public }));
    await this.props.dispatch(listChatQuestions(active));
  };

  handleVisiblePublic = async (id: number, visible_customers: boolean) => {
    const { active } = this.props;
    await this.props.dispatch(updateQuestion(active, id, { visible_customers }));
    await this.props.dispatch(listChatQuestions(active));
  };

  handleDelete = async (id: number, deleteMessage: boolean) => {
    const { active } = this.props;
    this.setState({ isFetchingRemove: true });
    await this.props.dispatch(updateQuestion(active, id, { delete: deleteMessage }));
    this.setState({ isFetchingRemove: false });
    await this.props.dispatch(listChatQuestions(active));
  };

  handleToggleModalDelete = (chat_id?: number) => {
    this.setState({ chatActive: chat_id ? chat_id : 0, modalDelete: !this.state.modalDelete });
  };

  render() {
    const { classes, listChatQuestions, answerQuestion } = this.props;
    const { valueAnswer, modalDelete, chatActive, isFetchingRemove } = this.state;

    return (
      <React.Fragment>
        <div className={classes.questionsWrapper}>
          <div className={classes.questionChat}>
            <div className={classes.questionChatBody}>
              {!listChatQuestions.isFetching &&
                Array.isArray(listChatQuestions) &&
                listChatQuestions.map((chat: any) => {
                  return (
                    <div key={`chat-${chat.id}`} className={`${classes.questionsChatMessage} ${chat.is_producer ? '--producer' : ''}`}>
                      <div className={`${classes.questionChatName} ${chat.is_producer ? '--producer' : ''}`}>
                        {chat.is_producer && (
                          <React.Fragment>
                            <span>
                              {moment(chat.asked_at).format('DD/MM/YYYY')} às {moment(chat.asked_at).format('H:mm')}
                            </span>
                            Eu
                          </React.Fragment>
                        )}

                        {!chat.is_producer && (
                          <React.Fragment>
                            {chat.customer_name}
                            <span>
                              {moment(chat.asked_at).format('DD/MM/YYYY')} às {moment(chat.asked_at).format('H:mm')}
                            </span>
                          </React.Fragment>
                        )}
                      </div>
                      <div className={`${classes.questionChatContent} ${chat.is_producer ? '--producer' : ''}`}>{chat.question}</div>
                      <div className={`${classes.questionsChatIcons} ${chat.is_producer ? '--producer' : ''}`}>
                        <Tooltip placement='top' title={'Tornar ' + (chat.visible_public ? 'invisível' : 'visível') + ' na vitrine'}>
                          <span onClick={() => this.handleVisibleShowcase(chat.id, !chat.visible_public)}>
                            <Icon color={chat.visible_public ? 'secondary' : 'default'}>{chat.visible_public ? 'visibility' : 'visibility_off'}</Icon>
                          </span>
                        </Tooltip>
                        <Tooltip placement='top' title={'Tornar ' + (chat.visible_customers ? 'invisível' : 'visível') + ' ao público'}>
                          <span onClick={() => this.handleVisiblePublic(chat.id, !chat.visible_customers)}>
                            <Icon color={chat.visible_customers ? 'secondary' : 'default'} style={{ position: 'relative', top: 1 }}>
                              group
                            </Icon>
                          </span>
                        </Tooltip>
                        {chat.is_producer && (
                          <Tooltip placement='top' title={'Apagar resposta'}>
                            <span onClick={() => this.handleToggleModalDelete(chat.id)}>
                              <Icon>delete</Icon>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div className='m8'></div>

          <div className={classes.questionChatResponse}>
            <textarea
              className={classes.questionsTextarea}
              placeholder='Resposta...'
              onChange={this.handleChangeFieldResponse}
              value={valueAnswer}
            ></textarea>

            <div className='m8'></div>

            <div className={classes.questionChatButton}>
              <Button
                variant='contained'
                color='secondary'
                onClick={this.handleClickAnswer}
                disabled={!valueAnswer.length || answerQuestion.isFetching}
              >
                Responder
                {answerQuestion.isFetching && <CircularProgress size={15} style={{ marginLeft: 10 }} />}
              </Button>
            </div>
          </div>
        </div>

        <ModalActions
          open={modalDelete}
          onClose={this.handleToggleModalDelete}
          onOk={() => this.handleDelete(chatActive, true)}
          title={'Atenção'}
          buttonOk={'Remover'}
          loading={isFetchingRemove}
        >
          <p>Deseja realmente apagar esta mensagem?</p>
        </ModalActions>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    listChatQuestions: state.orbita.Questions.listChatQuestions,
    answerQuestion: state.orbita.Questions.answerQuestion,
  };
}

export default connect(mapStateToProps)(styles(Chat));
